<template>
  <div ref="table">
    <div class="dialog-container" @mouseleave="_leave" v-show="visbile">
      <el-link :underline="false" @click="add">添加子节点</el-link>
      <br />
      <el-link :underline="false" @click="edit">编辑节点</el-link>
      <br />
      <el-link :underline="false" @click="del">删除</el-link>
      <br />
      <!-- <label>菜单名称：</label>
    <input type="text" placeholder="菜单名称" ref="name" />
    <br />
    <label>链接：</label>
    <input type="text" placeholder="链接" ref="uri" />
    <br />
    <label>ID：</label>
    <input type="text" placeholder="ID" ref="id" />
    <br />
    <button @click="save">保存</button>
      <button @click="cancle">取消</button>-->
      <DialogDiv :onSave="onEdit" ref="editDialog"></DialogDiv>
      <DialogDiv :onSave="onAdd" ref="addDialog"></DialogDiv>
    </div>
  </div>
</template>

<script>
import DialogDiv from "./dialog.vue";

let dataitem
export default {
  name: "dialogdiv",
  data () {
    return {
      visbile: false,
      id: ''
    };
  },
  props: {
    onMenu: Function,
  },
  components: {
    DialogDiv,
  },
  methods: {
    add (data) {
      this.$refs.addDialog.show('add', dataitem.id);
      // this.visbile = false
      // this.visbile = true;
      // if (type === 'edit') {
      //   this.$refs.name.value = data.name;
      //   this.$refs.uri.value = data.uri;
      //   this.$refs.id.value = data.id;
      //   this.id = data.id;
      // } else {
      //   this.id = data;
      // }
    },
    edit (data) {
      this.$refs.editDialog.show('edit', dataitem);
    },
    del () {
      this.onMenu(dataitem.id, dataitem, 0);
      this.visbile = false;
    },
    save (list) {
      var data = {
        name: this.$refs.name.value,
        uri: this.$refs.uri.value,
        id: this.$refs.id.value
      }
      this.onMenu(this.id, data, typeid);
      this.visbile = false;
    },
    show (data) {
      this.visbile = true;
      // if (type === 'edit') {
      //   this.$refs.name.value = data.name;
      //   this.$refs.uri.value = data.uri;
      //   this.$refs.id.value = data.id;
      //   this.id = data.id;
      // } else {
      dataitem = data;
      // }
    },
    cancle () {
      this.visbile = false
    },
    _leave () {
      this.visbile = false
    },
    onAdd (id, data) {
      // this.onSave(this.id, data,1);
      // this.$refs.table.AddRow(pId, data)
      // console.log(dataitem.id, data, '555')
      // console.log(id, '5656')
      this.onMenu(dataitem.id, data, 1);
    },
    onEdit (id, data) {
      // this.$refs.table.EditRow(id, data)
      // this.onSave(this.id, data);
      this.onMenu(dataitem.id, data, 2);
    },
  }
};
</script>
<style lang="scss">
.dialog-container {
  position: fixed;
  background: #fff;
  top: 50%;
  left: 50%;
  margin-left: -150px;
  margin-top: -150px;
  box-shadow: 0px 0px 5px #ccc;
  label {
    display: inline-block;
    width: 80px;
  }
}
.el-link {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system-manage/treeTable/contextMenu.vue